<template>
    <div class="result-section" :class="getScoreDecorator()">

        <div class="decoration">
            <div class="frame"></div>
        </div>

        <div class="score-row">{{ copydeck.label_result_you_got }} <span class="score-section"><span
            class="result-count">{{ rightAnswer }}</span>
            {{ copydeck.label_result_separator }} {{ totalQuestionCount }}</span> {{
                copydeck.label_result_good_answers
            }}
        </div>


        <div> {{ quizReaction }}</div>
        <div v-html="quiz.data.feedback"></div>


        <form class="sharing-section" v-if="!hasShared" @submit.prevent="sendToMember">

            <div>{{ copydeck.label_share_your_score }}</div>
            <div class="share-row">
                <div><label for="quiz-share-members"> {{ copydeck.label_member_name }}</label></div>
                <div class="quiz-share-dropdown-container">
                    <select class="quiz-share-members"
                            id="quiz-share-members"
                            v-model="memberName"
                            ref="quizShareMembersField"
                    >
                        <option></option>
                    </select>
                </div>
            </div>

            <div class="error"
                 ref="errorContainer"
                 v-html="errorText"
                 v-if="hasSendError"></div>

            <div class="centered submit-container">
                <button :disabled="memberName === ''"
                        class="btn link-show-all white"
                        v-if=" loggedIn "
                >{{ copydeck.btnSendToMember }}
                </button>
                <button

                    class="btn link-show-all white"
                    @click="showLogin"
                   v-if=" !loggedIn "
                >{{ copydeck.btnSendToMember }}
                </button>
            </div>


        </form>


        <div class="sharing-section shared" v-if="hasShared" v-html=" sharedSuccess "></div>


    </div>
</template>

<script setup>

import axios from "axios";

import { computed, ref, onMounted } from "vue";
import { useStore }                 from "vuex";
import { sample }                   from "lodash-es"
import useCopydeck                  from "../composables/UseCopydeck";

import { randomIntFromInterval } from "../../Utils";


const store    = useStore();
const copydeck = useCopydeck();
let emits      = defineEmits( [ "show-screen", "jump-to-top" ] )

const quiz               = computed( () => store.state.quiz );
const questions          = ref( quiz.value.questions );
const totalQuestionCount = ref( questions.value.length );
let memberName           = ref( "" );

let sharedSuccess = computed( () =>
{
    return copydeck.sharedSuccess.fr.replace( '[username]', memberName.value );
} );

let hasShared = ref( false );


let rightAnswer      = computed( () => store.state.rightAnswers );
let rightAnswerRatio = computed( () => Math.round( rightAnswer.value / totalQuestionCount.value * 100 ) );

let hasSendError   = ref( false );
let errorContainer = ref( null );
let errorText      = ref( '' );

let quizShareMembersField = ref( null );

let loggedIn = ref( false );

let quizReaction = computed( () =>
{

    let ratio         = rightAnswerRatio.value;
    let quizReactions = store.state.quizReactions.filter( qr => qr.data.min <= ratio && qr.data.max >= ratio );

    let reaction = sample( quizReactions ); //choose randomly

    return reaction.reaction ?? "";

} );

async function sendToMember ( e )
{

    hasSendError.value = false;

    let message   = copydeck.shareMessage.fr;
    let quizTitle = document.querySelector( '.page-title' ).innerHTML;
    let quizUrl   = window.location;

    message = message
        .replace( '[username]', memberName.value )
        .replace( '[userpoints]', rightAnswer.value )
        .replace( '[totalpoints]', totalQuestionCount.value )
        .replace( '[quiztitle]', quizTitle )
        .replace( '[quizurl]', `<a href="${quizUrl}" target="_blank">${quizUrl}</a>` );

    let payload = { receiver : memberName.value, message : message };

    let response = await axios.post( "/endpoints/quiz-message/send", payload );

    if ( response.data.success )
    {
        hasShared.value  = true;
        memberName.value = "";
    } else
    {
        errorText.value    = response.data.error;
        hasSendError.value = true;
    }


}

function showLogin ()
{
    const event = new Event( 'openExplanationJeunes' );
    window.dispatchEvent( event );


}

function mounted ()
{
    document.querySelector( 'body' ).classList.remove( 'has-incomplete-quiz' );

    let existingUserAnswers           = store.getters.userAnswers;
    existingUserAnswers[ 'complete' ] = true;
    store.commit( "userAnswers", existingUserAnswers );

    sendUserAnswers();

    setupSelect2();
}

onMounted( mounted );


async function sendUserAnswers ()
{
    try
    {

        const response = await axios.post( '/endpoints/quiz-user-answers', {
            id_quiz : quiz.value.id,
            answers : store.getters.userAnswers,
        } );


        loggedIn.value = true;

    }
    catch (error)
    {
        console.error( '[Quiz] Something went sideways, trying to send the Quiz answers to the server.', error );

        loggedIn.value = false;
    }
}

function getScoreDecorator ()
{
    const score = rightAnswer.value / totalQuestionCount.value;
    let rank    = 0;

    if ( score > (2 / 3) )
    {
        rank = 1;

    } else if ( score > (1 / 3) )
    {

        rank = 2;

    } else
    {

        rank = 3;

    }


    return 'result-decoration_' + rank;
}


function setupSelect2 ()
{

    // https://select2.org/data-sources/ajax

    let selectOptions = {
        // minimumResultsForSearch : Infinity,
        placeholder : copydeck.label_member_name.fr,
        // width                   : 'resolve',
        language : {
            inputTooShort : function ()
            {
                return "";
            },
        },
        // allowClear : true,
        minimumInputLength : 3,

        ajax : {
            url      : '/simple-users-list',
            dataType : 'json',
            delay    : 250,
            data     : function ( params )
            {

                return {
                    search : params.term,
                    // type: 'public'
                };
            },
        },

    };


    selectOptions.dropdownParent = $( quizShareMembersField.value ).parent();


    $( quizShareMembersField.value ).select2( selectOptions )
        .on( 'select2:select', function ( e )
        {
            var data = e.params.data;

            memberName.value = data.text;
        } );
}

</script>

<style scoped>

</style>
